export default {"src":"/_next/static/media/backgroundClosedDocEnVille50.38bc4048.svg","height":167,"width":464,"blurWidth":0,"blurHeight":0};